/* src/app/indirect-rate/indirect-rate-management/indirect-rate-management-presenter/indirect-rate-management-presenter.component.scss */
/*# sourceMappingURL=indirect-rate-management-presenter.component.css.map */
